<!-- Delete Comment Dialog-->
<ui-dialog
    [open]="isDeleteCommentDialogOpen"
    (closing)="closeDeleteCommentDialog()"
    header="applicant-tracker.deleteComment"
>
    <p>{{ 'applicant-tracker.areYouSureYouWantToDeleteThisComment' | appTranslate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeleteCommentDialog()">{{ 'cancel' | appTranslate }}</ui-button>
        <ui-button type="danger" (click)="onDeleteComment()">{{ 'delete' | appTranslate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-card [loading]="isLoading">
    <app-segment-header
        class="mini-comments-header"
        title="applicant-tracker.components.comment.title"
    ></app-segment-header>
    <ng-container *ngFor="let discussion of applicantDiscussions">
        <app-discussion-comment
            [new]="true"
            [miniState]="true"
            [hiringTeam]="hiringTeam"
            (save)="onSaveComment($event, discussion)"
        ></app-discussion-comment>
        <app-discussion-comment
            id="comment-{{ comment.id }}"
            *ngFor="let comment of discussion.discussionComments | slice: 0 : 3"
            [comment]="comment"
            [hiringTeam]="hiringTeam"
            [miniState]="true"
            (save)="onSaveComment($event, discussion)"
            (delete)="openDeleteCommentDialog($event)"
        ></app-discussion-comment>
    </ng-container>
    <ui-button type="link" (click)="viewAllComments()">{{
        'applicant-tracker.viewAllComments' | appTranslate
    }}</ui-button>
</ui-card>
